import {directoryService} from '../services/directory';
import type {DirectorySource} from '../types/directory';

function resolveRequestSource(source: DirectorySource) {
  if (source === 'navigation' || source === 'mixed') {
    return directoryService.getNavigationDirectory;
  }

  return directoryService.getDirectory;
}

export const directoryAdapter = {
  async getChildren(parentId: number, source: DirectorySource = 'directory', rootId = 1) {
    const request = resolveRequestSource(source);

    const res = await request({
      parent_id: parentId,
      page: 1,
      page_size: 1000
    });

    const children = res.items
      .filter((item: any) => item.type === 'directory')
      .sort((a: any, b: any) => {
        // 只处理根目录第一层
        if (parentId !== rootId) return 0;

        if (a.is_private) return 1;
        if (b.is_private) return -1;

        return 0;
      });

    return {
      currentDirectory: res.current_directory,
      children,
    };
  }
};